var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFilter = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3201_25476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2381 4.1725L14.2331 4.17812L10 8.69812V12.1663C10.0003 12.3312 9.9597 12.4936 9.88195 12.6391C9.8042 12.7846 9.69167 12.9086 9.55439 13L7.55439 14.3337C7.40367 14.4341 7.22852 14.4917 7.04763 14.5003C6.86675 14.509 6.68691 14.4683 6.52733 14.3827C6.36774 14.2971 6.2344 14.1698 6.14153 14.0143C6.04866 13.8589 5.99975 13.6811 6.00001 13.5V8.69812L1.76689 4.17812L1.76189 4.1725C1.63173 4.02926 1.54594 3.85133 1.51491 3.66029C1.48389 3.46924 1.50897 3.27331 1.58712 3.09624C1.66526 2.91917 1.79311 2.76859 1.95515 2.66275C2.1172 2.55692 2.30647 2.50038 2.50001 2.5H13.5C13.6937 2.50002 13.8832 2.55629 14.0456 2.66199C14.2079 2.76768 14.336 2.91825 14.4144 3.09538C14.4928 3.27252 14.518 3.46861 14.4871 3.65982C14.4561 3.85104 14.3703 4.02914 14.24 4.1725H14.2381Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3201_25476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter.792b7212.svg";
export { ForwardRef as ReactComponent };